document.addEventListener('DOMContentLoaded', function () {

  function isDesktop() {
    return window.innerWidth >= 1025;
  }

  function getMenu() {
    return document.querySelector('[data-hp-menu]');
  }

  function getButton(e) {
    return e.target.closest('.header-modal-mainmenu__button');
  }

  function positionMenuUnderButton(btn, menu) {

  const anchor =
    btn.closest('.header__btn, .header__icons, .header-user-icons, header')
    || btn.parentElement;

  if (!anchor.contains(menu)) {
    anchor.style.position = anchor.style.position || 'relative';
    anchor.appendChild(menu);
  }

  const btnRect = btn.getBoundingClientRect();
  const anchorRect = anchor.getBoundingClientRect();

  const top = btnRect.bottom - anchorRect.top + 8; // 8px spacing
  const left = btnRect.left - anchorRect.left;

  menu.style.position = 'absolute';
  menu.style.top = top + 'px';
  menu.style.left = left + 'px';
  menu.style.right = 'auto';
}


  function openMenu(btn, menu) {
    positionMenuUnderButton(btn, menu);
    menu.removeAttribute('hidden');

    const firstParent = menu.querySelector('[data-hp-parent][data-index="0"]');
    if (firstParent) {
      firstParent.classList.add('is-active');
      firstParent.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMenu(menu) {
    menu.setAttribute('hidden', '');
  }

  // Hamburger click
  document.addEventListener('click', function (e) {

    if (!isDesktop()) return;

    const btn = getButton(e);
    const menu = getMenu();
    if (!btn || !menu) return;

    e.preventDefault();
    e.stopPropagation();

    const isOpen = !menu.hasAttribute('hidden');

    if (isOpen) {
      closeMenu(menu);
    } else {
      openMenu(btn, menu);
    }

  }, true); // capture phase so we beat Wokiee modal

  // Switch subpanels on hover
  document.addEventListener('mouseover', function (e) {

    if (!isDesktop()) return;

    const parent = e.target.closest('[data-hp-parent]');
    const menu = getMenu();
    if (!parent || !menu || menu.hasAttribute('hidden')) return;

    const idx = parent.getAttribute('data-index');

    menu.querySelectorAll('[data-hp-parent]').forEach(a => {
      const active = a === parent;
      a.classList.toggle('is-active', active);
      a.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-hp-subpanel]').forEach(panel => {
      panel.toggleAttribute(
        'hidden',
        panel.getAttribute('data-hp-subpanel') !== idx
      );
    });

  });

  // Close when clicking outside
  document.addEventListener('click', function (e) {

    if (!isDesktop()) return;

    const menu = getMenu();
    if (!menu || menu.hasAttribute('hidden')) return;

    const clickedInside =
      e.target.closest('[data-hp-menu]') ||
      e.target.closest('.header-modal-mainmenu__button');

    if (!clickedInside) {
      closeMenu(menu);
    }

  });

  // Close if resizing to mobile
  window.addEventListener('resize', function () {
    const menu = getMenu();
    if (!menu) return;
    if (!isDesktop()) closeMenu(menu);
  });

});